"use client";

import { useState, useEffect, useRef } from "react";
import "./Products.css";
import end from "../assets/products/easy-open-1.jpg";
import end2 from "../assets/products/easy-open-2.jpg";
import can1 from "../assets/products/metal-tins-1.jpg";
import can2 from "../assets/products/metal-tins-2.jpg";
import can3 from "../assets/products/metal-tins-3.jpg";
import can4 from "../assets/products/metal-tins-4.jpg";
import can5 from "../assets/products/metal-tins-5.jpg";
import can6 from "../assets/products/metal-tins-6.jpg";
import can7 from "../assets/products/metal-tins-7.jpg";
import cap from "../assets/products/plastic-cap-1.jpg";
import lid1 from "../assets/products/slip-1.jpg";
import lid2 from "../assets/products/slip-2.jpg";
import spoon from "../assets/products/plastic-sppons-1.jpg";
import tin from "../assets/products/ointment-tins-1.jpg";
import peel from "../assets/products/peel-off-1.jpg";
import pp from "../assets/products/aluminium-pp-caps-1.jpg";
import clear from "../assets/products/clear_cans.png";

const Products = () => {
  const [activeCategory, setActiveCategory] = useState("all");
  const [currentSlide, setCurrentSlide] = useState(0);
  const sectionRef = useRef(null);
  const carouselRef = useRef(null);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const categories = [
    { id: "all", name: "All Products" },
    { id: "ends", name: "Easy Open Ends" },
    { id: "cans", name: "Metal Tin Cans/Food Cans" },
    { id: "caps", name: "Plastic Caps" },
    { id: "lids", name: "Slip In Lid" },
    { id: "spoons", name: "Plastic Spoons/Measuring Cups" },
    { id: "tins", name: "Ointment Tins" },
    { id: "peels", name: "Peel Off Ends" },
    { id: "pps", name: "Aluminium PP Caps" },
    { id: "pets", name: "Clear Cans" },
  ];

  const products = [
    {
      id: 1,
      name: "Easy Open Ends (Tin)",
      category: "ends",
      image: end,
      sizes: [200, 202, 209, 211, 300, 307, 401, 404],
      // description: "High-quality tin cans perfect for food packaging with customizable printing options.",
    },
    {
      id: 2,
      name: "Easy Open Ends (Aluminium)",
      category: "ends",
      image: end2,
      sizes: [200, 202, 209, 211, 300, 307, 401, 404],
      // description: "Durable tin cans designed specifically for paints and coatings.",
    },
    {
      id: 3,
      name: "Metal Tin Cans/Food Cans",
      category: "cans",
      image: can1,
      sizes: [211, 300, 301, 307, 401],
      // description: "Convenient pull-tab easy open ends for seamless consumer experience.",
    },
    {
      id: 4,
      name: "Metal Tin Cans/Food Cans",
      category: "cans",
      image: can2,
      sizes: [211, 300, 301, 307, 401],
      // description: "Larger diameter easy open ends for industrial and food applications.",
    },
    {
      id: 5,
      name: "Metal Tin Cans/Food Cans",
      category: "cans",
      image: can3,
      sizes: [211, 300, 301, 307, 401],
      // description: "Secure slip-in lids that provide airtight sealing for various containers.",
    },
    {
      id: 6,
      name: "Metal Tin Cans/Food Cans",
      category: "cans",
      image: can4,
      sizes: [211, 300, 301, 307, 401],
      // description: "Durable plastic screw caps with customizable colors and tamper-evident options.",
    },
    {
      id: 7,
      name: "Metal Tin Cans/Food Cans",
      category: "cans",
      image: can5,
      sizes: [211, 300, 301, 307, 401],
      // description: "Precise measuring spoons for powdered products, available in various sizes.",
    },
    {
      id: 8,
      name: "Metal Tin Cans/Food Cans",
      category: "cans",
      image: can6,
      sizes: ["Custom"],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
    {
      id: 9,
      name: "Metal Tin Cans/Food Cans",
      category: "cans",
      image: can7,
      sizes: ["Custom"],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
    {
      id: 10,
      name: "Plastic Caps",
      category: "caps",
      image: cap,
      sizes: [202, 211, 300, 307, 401, 404],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
    {
      id: 11,
      name: "Slip In Lid - Top",
      category: "lids",
      image: lid1,
      sizes: [45, 52, 63, 65, 68, 73, 74, 75, 83, 88, 95, 99, 105],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
    {
      id: 12,
      name: "Slip In Lid - Bottom",
      category: "lids",
      image: lid2,
      sizes: [45, 52, 63, 65, 68, 73, 74, 75, 83, 88, 95, 99, 105],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
    {
      id: 13,
      name: "Plastic Spoons/Measuring Cups",
      category: "spoons",
      image: spoon,
      sizes: ["Spoon - 200gm, 400gm", "Measuring Cup - 10ml, 90ml"],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
    {
      id: 14,
      name: "Ointment Tins",
      category: "tins",
      image: tin,
      sizes: ["Custom"],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
    {
      id: 15,
      name: "Peel Off Ends",
      category: "peels",
      image: peel,
      sizes: [200, 202, 209, 211, 300, 307, 401, 404],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
    {
      id: 16,
      name: "Aluminium PP Caps",
      category: "pps",
      image: pp,
      sizes: [22, 25, 28],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
    {
      id: 17,
      name: "Clear Cans",
      category: "pets",
      image: clear,
      // sizes: [22, 25, 28],
      sizes: [45, 52, 63, 65, 68, 73, 74, 75, 83, 88, 95, 99, 105],
      // description: "Fully customizable tin cans with your branding and design specifications.",
    },
  ];

  const filteredProducts =
    activeCategory === "all"
      ? products
      : products.filter((product) => product.category === activeCategory);

  const totalSlides = filteredProducts.length;

  const getSlidesToShow = () => {
    const width = window.innerWidth;
    if (width >= 1024) return 3;
    if (width >= 768) return 2;
    return 1;
  };

  const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow());
  const [slideWidth, setSlideWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const newSlidesToShow = getSlidesToShow();
      setSlidesToShow(newSlidesToShow);
      setCurrentSlide(0);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setCurrentSlide(0);
  }, [activeCategory]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = sectionRef.current.querySelectorAll(".animate-in");
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, [activeCategory, filteredProducts]);

  useEffect(() => {
    if (carouselRef.current) {
      const firstSlide = carouselRef.current.querySelector(".carousel-slide");
      if (firstSlide) {
        setSlideWidth(firstSlide.offsetWidth);
      }
    }
  }, [filteredProducts, slidesToShow]);

  const totalPositions = totalSlides - slidesToShow + 1; // Total number of positions (e.g., 6 for 8 slides, 3 per view)
  const totalGroups = Math.ceil(totalSlides / slidesToShow); // Number of dots

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalPositions);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalPositions) % totalPositions);
  };

  const goToSlide = (index) => {
    const newSlide =
      index * Math.ceil((totalSlides - slidesToShow + 1) / totalGroups);
    setCurrentSlide(Math.min(newSlide, totalSlides - slidesToShow));
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!touchStartX.current || !touchEndX.current) return;
    const diffX = touchStartX.current - touchEndX.current;
    if (diffX > 50) {
      nextSlide();
    } else if (diffX < -50) {
      prevSlide();
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };

  // Calculate the active dot based on the current slide
  const slidesPerDot = Math.ceil(totalPositions / totalGroups); // Number of slide positions per dot
  const activeDot = Math.min(
    Math.floor(currentSlide / slidesPerDot),
    totalGroups - 1
  );

  return (
    <div className="products" ref={sectionRef}>
      <div className="container">
        <h2 className="text-center animate-in">Our Products</h2>
        <p className="products-subtitle text-center animate-in">
          Explore our comprehensive range of high-quality packaging solutions
        </p>

        <div className="product-categories animate-in">
          {categories.map((category) => (
            <button
              key={category.id}
              className={`category-btn ${
                activeCategory === category.id ? "active" : ""
              }`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        <div
          className="products-carousel"
          ref={carouselRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className="carousel-wrapper">
            <div
              className="carousel-slides"
              style={{
                transform: `translateX(-${currentSlide * slideWidth}px)`,
                transition: "transform 0.5s ease",
                width: `${filteredProducts.length * (350 + 30)}px`,
                maxWidth: `${Math.min(1200, window.innerWidth - 40)}px`,
              }}
            >
              {filteredProducts.map((product, index) => (
                <div
                  className="carousel-slide animate-in"
                  key={product.id}
                  style={{ width: `${350 + 30}px` }}
                >
                  <div className="product-card">
                    <div className="product-image">
                      <img
                        src={product.image || "https://via.placeholder.com/300"}
                        alt={product.name}
                      />
                    </div>
                    <div className="product-details">
                      <h3>{product.name}</h3>
                      <p>{product.description}</p>
                      <div className="product-sizes">
                        <span className="sizes-label">Available sizes:</span>
                        <div className="sizes-list">
                          {product.sizes.map((size) => (
                            <span className="size-tag" key={size}>
                              {size}
                            </span>
                          ))}
                        </div>
                      </div>
                      <button className="btn btn-outline product-btn">
                        Request Quote
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {totalSlides > slidesToShow && (
            <>
              <button className="carousel-prev" onClick={prevSlide}>
                ❮
              </button>
              <button className="carousel-next" onClick={nextSlide}>
                ❯
              </button>
              <div className="carousel-dots">
                {Array.from({ length: totalGroups }).map((_, index) => (
                  <span
                    key={index}
                    className={`carousel-dot ${
                      activeDot === index ? "active" : ""
                    }`}
                    onClick={() => goToSlide(index)}
                  ></span>
                ))}
              </div>
            </>
          )}
        </div>

        <div className="products-cta text-center animate-in">
          <h3>Need a custom solution?</h3>
          <p>
            We can create custom packaging solutions tailored to your specific
            requirements.
          </p>
          <a href="#contact" className="btn">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default Products;
